import script from "./QuickpaySettingsBlockPreferences.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickpaySettingsBlockPreferences.vue?vue&type=script&setup=true&lang=ts"

import "./QuickpaySettingsBlockPreferences.vue?vue&type=style&index=0&id=65dc8a46&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65dc8a46"]])

export default __exports__